module.exports = __webpack_public_path__ + "img/pdf.57587f3e.png";